import Swiper, {Autoplay, Pagination, Navigation} from "swiper";

Swiper.use([Autoplay, Pagination, Navigation]);

export class MainSlider {
    constructor() {
        this.$block = document.getElementById('main_slider_block');
        if (!this.$block) return;

        this.$slider = document.getElementById('main_slider');
        this.$pxl = document.getElementById('main_slider_block_pxl');

        this.heightSliderBlock = this.getHeightSliderBlock();
        this.slider = this.initSlider();

        this.init();
    }

    init() {
        this.onScrollHandler();

        window.addEventListener('scroll', () => {
            this.onScrollHandler();
        });

        window.addEventListener('resize', () => {
            this.heightSliderBlock = this.getHeightSliderBlock();
        });
    }

    initSlider() {
        const isMobile = window.innerWidth < 1000;

        let paginationSettings = {};

        if (isMobile) {
            paginationSettings = {
                el: '.mobile-pagination',
                type: 'bullets',
                clickable: true
            };
        } else {
            paginationSettings = {
                el: '.desktop-pagination',
                clickable: true,
                type: 'bullets',
                renderBullet: function (index, className) {
                    return `
                   <div class="${className}">
                      <svg class="progress" width="24" height="24">
                          <circle class="circle-background" r="8" cx="12" cy="12"></circle>
                          <circle class="circle-progress" r="8" cx="12" cy="12"></circle>
                      </svg>
                  </div>`;
                }
            };
        }

        return new Swiper('#main_slider', {
            effect: 'slide',
            loop: false,
            preloadImages: false,
            lazy: true,
            resistance: false,
            speed: 1000,
            spaceBetween: 32,
            modules: [Pagination, Autoplay],
            pagination: paginationSettings,
            navigation: {
                nextEl: '.main-slider-button-next',
                prevEl: '.main-slider-button-prev'
            },
            nextSlideMessage: '',
            prevSlideMessage: '',
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            on: {
                afterInit: function () {
                    if (!isMobile) {
                        const $firstBullet = document.querySelector('.desktop-pagination .swiper-pagination-bullet:first-child');
                        if ($firstBullet) {
                            $firstBullet.classList.remove('swiper-pagination-bullet-active');
                            requestAnimationFrame(() => {
                                $firstBullet.classList.add('swiper-pagination-bullet-active');
                                const $circleProgress = $firstBullet.querySelector('.circle-progress');
                                if ($circleProgress) {
                                    $circleProgress.style.transition = 'stroke-dashoffset 4.5s linear';
                                }
                            });
                        }
                    }
                }
            }
        });
    }

    getHeightSliderBlock() {
        return +this.$block.offsetHeight;
    }

    onScrollHandler() {
        const top = pageYOffset * 0.2 + 'px';
        const percent = Math.round(pageYOffset / this.heightSliderBlock * 100) / 100;
        const opacity = percent * 1 - 0.2;
        this.$block.style.transform = `translateY(${top})`;

        if (percent > 0.2) {
            this.$pxl.classList.remove('hide');
            this.$pxl.style.opacity = `${opacity}`;

        } else {
            this.$pxl.classList.add('hide');
        }
    }
}
